var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCutout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_2128_526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.92578V17.7842C0 17.9041 0.0971048 18.0012 0.216993 18.0012H1.30461C1.4245 18.0012 1.5216 17.9041 1.5216 17.7842V14.8793H16.495V17.7842C16.495 17.9041 16.5921 18.0012 16.712 18.0012H17.7996C17.9195 18.0012 18.0166 17.9041 18.0166 17.7842V7.92578H0ZM9.00841 12.2077C8.5638 12.2077 8.20325 11.8471 8.20325 11.4025C8.20325 10.9579 8.5638 10.5974 9.00841 10.5974C9.45301 10.5974 9.81356 10.9579 9.81356 11.4025C9.81356 11.8471 9.45301 12.2077 9.00841 12.2077Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4041 0H0.612711C0.274282 0 0 0.274282 0 0.612711V6.95372H18.0168V0.612711C18.0168 0.274282 17.7425 0 17.4041 0ZM9.00841 4.2819C8.5638 4.2819 8.20325 3.92135 8.20325 3.47675C8.20325 3.03215 8.5638 2.6716 9.00841 2.6716C9.45301 2.6716 9.81356 3.03215 9.81356 3.47675C9.81356 3.92135 9.45301 4.2819 9.00841 4.2819Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0168,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutout);
export default __webpack_public_path__ + "static/media/cutout.40e85e43a0c9c4182182e23e8dc551ab.svg";
export { ForwardRef as ReactComponent };